import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PanelContent from '@portal/components/PanelContent/PanelContent';

import { getRouteStackPath } from '@portal/config/routes';
import { translate } from '@portal/services/i18n';

import LoanPage from './LoanPage/LoanPage';
import LoanRegister from './LoanRegister/LoanRegister';
import SimulateLoan from './SimulateLoan/SimulateLoan';

const LoanNavigationStack = () => {
  return (
    <Switch>
      <Route exact path={getRouteStackPath('LOAN', 'LOAN_PAGE')}>
        <PanelContent pageTitle={translate('PAGES.LOAN.TITLE')}>
          <LoanPage />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('LOAN', 'SIMULATE')}>
        <PanelContent pageTitle={translate('PAGES.LOAN.SIMULATE.TITLE')}>
          <SimulateLoan />
        </PanelContent>
      </Route>
      <Route exact path={getRouteStackPath('LOAN', 'REGISTER')}>
        <PanelContent pageTitle={translate('PAGES.LOAN.REGISTER.TITLE')}>
          <LoanRegister />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default LoanNavigationStack;
